/**
 * The ONE mapper from an axios failure to what a screen needs -- phase 6b, Task 1.
 *
 * Status classes (ADMIN_API.md "The 422 shape"):
 * - 422 `{ errors: [{ path, message }], userMessage }` -> `fieldErrors` keyed
 *   by dotted path (`tiers.1.minLifetimeSpend`), first message per path wins;
 *   a whole-body issue has path '' and lands only in `message`.
 * - 409 / 400 / anything else with a `userMessage` or `message` -> `message`
 *   for a snackbar; `fieldErrors` stays empty.
 * - bare 403 / 404 / other -> fixed copy; no response at all -> status 0
 *   "Network error.".
 */
export type ApiFailure = { status: number; message: string; fieldErrors: Record<string, string> };

export function toApiFailure(err: unknown): ApiFailure {
  const ax = err as { response?: { status?: number; data?: any } };
  const status = ax?.response?.status ?? 0;
  const data = ax?.response?.data ?? {};
  const fieldErrors: Record<string, string> = {};
  if (status === 422 && Array.isArray(data.errors)) {
    for (const e of data.errors) if (e?.path && e?.message && !fieldErrors[e.path]) fieldErrors[e.path] = e.message;
  }
  const message =
    data.userMessage ||
    data.message ||
    (status === 403
      ? "You don't have permission to do that."
      : status === 404
        ? 'Not found.'
        : status
          ? `Request failed (${status}).`
          : 'Network error.');
  return { status, message, fieldErrors };
}
